import React, { useEffect, useState } from "react";
import { postData, serverURL } from "../../services/NodeServices";
import { useNavigate } from "react-router-dom";
import ProductList from "../../TailwindComponent/List/List";

const YouMayAlsoLike = ({ category, currentProductId }) => {
  const navigate = useNavigate();
  
  // State for each subcategory
  const [tshirtProducts, setTshirtProducts] = useState([]);
  const [hoodiesProducts, setHoodiesProducts] = useState([]);
  const [sweatshirtProducts, setSweatshirtProducts] = useState([]);
  
  const [loadingTshirt, setLoadingTshirt] = useState(true);
  const [loadingHoodies, setLoadingHoodies] = useState(true);
  const [loadingSweatshirt, setLoadingSweatshirt] = useState(true);

  // Function to get products for a specific subcategory
  const getProductsBySubcategory = async (categoryName, subcategoryName, setter, setLoading) => {
    try {
      setLoading(true);
      const results = await postData("api/products/topby", {
        productcategoryname: categoryName,
        productsubcategoryname: subcategoryName,
      });
      
      if (results.status && results.data) {
        let products = results.data;
        
        // Filter out current product if provided
        if (currentProductId) {
          products = products.filter(product => 
            product.id !== currentProductId && product._id !== currentProductId
          );
        }
        
        // Limit to 4 products per category
        setter(products.slice(0, 4));
      }
    } catch (err) {
      console.error(`Error fetching ${subcategoryName}:`, err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch all subcategories when category changes
  useEffect(() => {
    if (!category) return;
    
    const categoryName = category.charAt(0).toUpperCase() + category.toLowerCase().slice(1);
    
    // Fetch T-Shirts
    getProductsBySubcategory(categoryName, "T-Shirts", setTshirtProducts, setLoadingTshirt);
    
    // Fetch Hoodies
    getProductsBySubcategory(categoryName, "Hoodies", setHoodiesProducts, setLoadingHoodies);
    
    // Fetch Sweatshirts
    getProductsBySubcategory(categoryName, "Sweatshirt", setSweatshirtProducts, setLoadingSweatshirt);
    
  }, [category, currentProductId]);

  // Handle product click with scroll position management
  const handleProductClick = (product_id) => {
    const scrollY = window.scrollY;
    sessionStorage.setItem("scrollPosition", scrollY.toString());

    setTimeout(() => {
      navigate(`/view/${product_id}`);
    }, 50);
  };

  // Handle scroll restoration
  useEffect(() => {
    const savedPosition = sessionStorage.getItem("scrollPosition");

    if (savedPosition) {
      window.scrollTo({ top: parseInt(savedPosition), behavior: "auto" });
      sessionStorage.removeItem("scrollPosition");
    } else {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }, []);

  // Don't render if no category provided
  if (!category) {
    return null;
  }

  return (
    <section className="you-may-also-like mb-20 pt-8">
      <div className="container mx-auto px-4">
      
        {/* T-Shirts Section */}
        <div className="mb-12">
        
          <ProductList
            loading={loadingTshirt}
            products={tshirtProducts}
            onProductClick={handleProductClick}
            title=""
          />
        </div>

        {/* Hoodies Section */}
        <div className="mb-12">
        
          <ProductList
            loading={loadingHoodies}
            products={hoodiesProducts}
            onProductClick={handleProductClick}
            title=""
          />
        </div>

        {/* Sweatshirts Section */}
        <div className="mb-12">
         
          <ProductList
            loading={loadingSweatshirt}
            products={sweatshirtProducts}
            onProductClick={handleProductClick}
            title=""
          />
        </div>
      </div>
    </section>
  );
};

export default YouMayAlsoLike;